module.exports = __webpack_public_path__ + "assets/img/B3-Cricket.6e340419.png";